module.exports = __webpack_public_path__ + "img/bms_system.d1f5d803.png";